import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { Checkbox } from "#components/atoms/Checkbox/Checkbox";
import { Text } from "#components/atoms/Typographies/Text";
import { Modal } from "#components/molecules/Modal/Modal";

type Props = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  checkboxProps: {
    id: string;
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  };
};

export const AddBatchDisclaimerModal = ({ opened, onClose, onConfirm, checkboxProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("quoteRequestV2.batch.disclaimerTitle")}
      closeText={t("quoteRequestV2.batch.cancel")}
      primaryText={t("quoteRequestLine.actions.addBatch")}
      onPrimary={onConfirm}
    >
      <Text size="small" color={colors.text.secondaryDefault}>
        {t("quoteRequestV2.batch.disclaimerText")}
      </Text>
      <Checkbox {...checkboxProps} label={t("quoteRequestV2.batch.dontShowAgain")} />
    </Modal>
  );
};
